import React from "react";
import "./styles/NetZero.scss";
// import BtnViewMore from "../../components/BtnViewMore";
import { useTranslation } from "react-i18next";
// import { useLangNavigate } from "../../hooks/useLangNavigate";
const NetZero = () => {
  const { t } = useTranslation();
  // const langNavigate = useLangNavigate();
  // const handleBtn = () => {
  //   langNavigate("/about_us", { state: { tap: 0 } });
  // };
  return (
    <>
      <div id="netzero_wrap">
        <div className="inner">
          <div className="text_wrap">
            <h2 className="main_title_font">{t("home.netzero.title")}</h2>
            {/* <BtnViewMore id="" onClick={handleBtn} /> */}
          </div>
          <div className="img_box">
            <img src="/imgs/bg_home_netzero_goal.png" alt="netzero_goal" />
          </div>
        </div>
      </div>
    </>
  );
};

export default NetZero;
